'use client'

import {FC} from 'react'

import {LegalDocumentationPage} from '@/components/legal-documentation/LegalDocumentationPage'
import {LegalDocumentationContent} from '@/utils/contentful'

type TermsAndConditionsProps = {
  termsAndConditions: LegalDocumentationContent
}

const TermsAndConditions: FC<React.PropsWithChildren<TermsAndConditionsProps>> = ({
  termsAndConditions,
}) => <LegalDocumentationPage content={termsAndConditions} />

export default TermsAndConditions
